import { GETTER } from './CONSTANTS';

export default {
  [GETTER.TAGS](state) {
    return (
      state.dashboard?.status_groups?.map(({ name, deals_count: count }) => ({
        name,
        count,
      })) ?? []
    );
  },
  [GETTER.SELECTED_TAG](state, getters) {
    return state.selectedTag ?? getters[GETTER.TAGS]?.[0];
  },
  [GETTER.EXPANDED_DEAL](state) {
    return state.expandedDeal;
  },
  [GETTER.COLUMNS](state) {
    return state.dashboard?.status_groups ?? [];
  },
  [GETTER.IS_LOADING](state) {
    return state.loading;
  },
  [GETTER.HAS_ERROR](state) {
    return Boolean(state.error);
  },
  [GETTER.ERROR](state) {
    return state.error;
  },
  [GETTER.IS_EXPANDED_DEAL_LOADING](state) {
    return state.expandedDealLoading;
  },
  [GETTER.CREATE_NOTE_MODAL_OPTIONS](state) {
    return state.createNoteModal;
  },
};
